import React from 'react';
import classNames from 'classnames';

import Input from '@material-ui/core/Input';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';

const PrecipYears = [{
        label: 'First year',
        name: 'asfc_yr1P'
    }, {
        label: 'Second Year',
        name: 'asfc_yr2P'
    }, {
        label: 'Third Year',
        name: 'asfc_yr3P'
    }, {
        label: 'Fourth Year',
        name: 'asfc_yr4P'
    }, {
        label: 'Fifth Year',
        name: 'asfc_yr5P'
    }]

const PrecipOptions = [{
        label: 'DRY',
        value: 'DRY'
    }, {
        label: 'WET',
        value: 'WET'
    }, {
        label: 'AVERAGE',
        value: 'AVERAGE'
    }]

const AersurfaceClimate = props => (
    <div style={{padding: '0px 0px 10px 0px'}}>
        <FormLabel>
            <table className={classNames(props.classes.margin)} style={{fontSize: '12px'}}>
                <tbody>
                    <tr>
                        <td>DRY: Precipitation amounts equal to or less than the 30th percentile of the 30-year climatological records</td>
                    </tr>
                    <tr>
                        <td>WET: Precipitation amounts equal to or greater than the 70th percentile of the 30-year climatological records</td>
                    </tr>
                    <tr>
                        <td>AVERAGE: Precipitation amounts between the 30th and 70th percentile of the 30-year climatological records</td>
                    </tr>
                </tbody>
            </table>
        </FormLabel>

        {PrecipYears.map(PrecipYears =>
            <FormControl key={PrecipYears.name} style={{minWidth: '150px'}} className={classNames(props.classes.margin, props.classes.formControl)}>
                <TextField
                    select
                    label={PrecipYears.label}
                    name={PrecipYears.name}
                    data-tip data-for=''
                    value={props[PrecipYears.name]}
                    onChange={props.handleInputChange}>

                    {PrecipOptions.map(option => (
                        <MenuItem key={option.value} value={option.value}>
                            {option.label}
                        </MenuItem>
                    ))}
                </TextField>
            </FormControl>
        )}
    </div>
)
export default AersurfaceClimate;
